import { datadogRum } from '@datadog/browser-rum';
import { getRequest, getRequestWithConfig } from './DataService';
import { Api, GloveBox, ReferenceTypes, AnalyticEvents } from '../constants';
import { isMyCarsReskinFixed } from '../utils/myCarsReskinExperiment';
import { Analytics } from './analytics-service';

const trackReskinEvent = (event: string, props: any) => {
  Analytics.trackEvent(event, props);
  datadogRum.addAction(event, props);
};

/*
  create specific ovp page data access methods, use the DataService
  'getRequest' and 'postRequest' methods to make the actual
  Http calls
*/

const normalizeReferenceType = (referenceType: any): string => {
  const normalized = String(referenceType ?? '')
    .trim()
    .toLowerCase();
  return normalized === ReferenceTypes.VEHICLE || normalized === ReferenceTypes.APPRAISAL
    ? normalized
    : ReferenceTypes.VEHICLE;
};

const hasInvalidPathSegment = (url: string): boolean => /\/(null|undefined)?\//i.test(url);

// GET Calls

export const getOVPDataApi: any = (
  vehicleId: number,
  referenceType: string,
  env: string,
  appInsightCallback?: (params: any) => void
) => {
  if (!isMyCarsReskinFixed()) {
    const url: string = `${Api.GET_OVP_DATA_API_URI}${referenceType}/${vehicleId}`;
    return getRequest({ url });
  }
  const url: string = `${Api.GET_OVP_DATA_API_URI}${normalizeReferenceType(referenceType)}/${vehicleId}`;
  if (hasInvalidPathSegment(url)) {
    trackReskinEvent(AnalyticEvents.myCarsReskinInvalidUrlBlocked, {
      endpoint: 'owned',
      url,
    });
    return Promise.resolve({ error: new Error(`Refusing to issue OVP request with invalid URL: ${url}`) });
  }
  return getRequest({ url });
};

export const getOVPMfeFeedDataApi: any = (
  vehicleId: number,
  referenceType: string,
  env: string,
  bucket: string,
  sarHighIntent?: string
) => {
  const fixed = isMyCarsReskinFixed();
  let url: string = `${Api.GET_OVP_MFE_FEED_API_URI}/${
    fixed ? normalizeReferenceType(referenceType) : referenceType
  }/${vehicleId}`;
  if (bucket && bucket === 'treatment') {
    url += `?isSarExperiment=true`;
  }
  if (fixed && hasInvalidPathSegment(url)) {
    trackReskinEvent(AnalyticEvents.myCarsReskinInvalidUrlBlocked, {
      endpoint: 'feed',
      url,
    });
    return Promise.resolve({ error: new Error(`Refusing to issue OVP feed request with invalid URL: ${url}`) });
  }
  return getRequest({
    url,
    headers: {
      'X-CVNA-SARs-High-Intent': (sarHighIntent && JSON.stringify(sarHighIntent)) || '',
    },
  });
};

export const downloadDocument: any = (documentName: string, url: string, env: string) => {
  // Only Purchase Contract uses APIK host, other documents have APIM host in the URL present by default
  const isApimUrl = GloveBox.FileName.indexOf(documentName) === -1;
  return getRequestWithConfig(isApimUrl, url, env, { responseType: 'blob' });
};
